<template>
  <div id="app">
    <!-- <div class="page_head">
            <span>游戏名称</span>
        </div> -->
    <pageHeader :title="gameInfo.gameName">
      <template v-slot:headerRight>
        <img
          src="@/assets/images/icon-share.png"
          @click="showShare = true"
          alt=""
        />
        <img
          @click="collectHandle"
          :src="
            gameInfo.collected && uuid
              ? require('@/assets/images/ic_collect_2.png')
              : require('@/assets/images/icon-collect.png')
          "
          alt=""
        />
      </template>
    </pageHeader>

    <div class="game_info">
      <div class="game_info_bg">
        <img class="bg_img" src="@/assets/images/bg_radious.png" alt="" />
      </div>

      <div class="game_detail">
        <div class="game_detail_top">
          <img class="game_logo" :src="gameInfo.logoUrl" alt="" />
          <div class="game_title_desc_type">
            <div class="game_title">{{ gameInfo.gameName }}</div>
            <div class="game_desc">{{ gameInfo.title }}</div>
            <div class="game_type">
              <div
                class="game_type_item"
                v-for="item in gameTypeList"
                :key="item"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="game_detail_bottom">
          <div class="game_redate">{{ gameInfo.discount }}</div>

          <div class="game_welfare">
            <div
              class="game_gift_btn"
              v-if="gameInfo.havaGift == 1"
              @click="tipMessage"
            >
              领取礼包
            </div>
            <div
              class="game_welfare_btn"
              v-if="gameInfo.gameWalfareList && gameInfo.gameWalfareList.length"
              @click="waterMarkHandle"
            >
              申请福利
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="game_content">
      <van-tabs
        color="#FF7A3E"
        class="vanTabs"
        v-model="active"
        title-active-color="#FF7A3E"
        title-inactive-color="#414141"
      >
        <van-tab title="详情">
          <div class="line_height"></div>
          <div class="game_video_detail">
            <div class="video-box">
              <slider ref="slider" :options="options">
                <!-- slideritem wrapped package with the components you need -->
                <slideritem
                  v-show="videoUrl"
                  :style="{ width: '90%', marginRight: '20px' }"
                >
                  <img
                    v-if="UBrowser != '-1' && poster"
                    class="video"
                    :src="poster"
                    alt=""
                  />
                  <video
                    v-else
                    :poster="poster"
                    class="video"
                    controls
                    :src="videoUrl"
                    webkit-playsinline
                    playsinline
                    x5-video-player-type="h5-page"
                  ></video>
                </slideritem>
                <slideritem
                  v-for="item in imgList"
                  :key="item"
                  :style="{ width: '40%', marginRight: '10px' }"
                >
                  <img class="sliderImg" :src="item" alt="" />
                </slideritem>
              </slider>
            </div>

            <div class="game_detail_info" v-html="gameInfo.gameDetail"></div>
          </div>
        </van-tab>
        <van-tab title="VIP价格">
          <div class="line_height"></div>

          <div
            class="vip_content"
            v-if="
              gameVipList.length == 0 &&
              vipDescribe != undefined &&
              vipDescribe != ''
            "
          >
            <span class="vip_tip">{{ vipDescribe }}</span>
          </div>

          <div class="vip_content" v-else-if="gameVipList.length > 0">
            <span class="vip_tip">（*仅供参考，以游戏内实际情况为准）</span>

            <v-table :tableData="gameVipList" :option="tableOption"></v-table>
          </div>

          <div class="empty" v-else>
            <img src="@/assets/images/empty.png" alt="" />
            <span>暂无相关信息</span>
          </div>
        </van-tab>
        <van-tab title="开服">
          <div class="line_height"></div>

          <div
            class="vip_content"
            v-if="
              allDateList.length == 0 &&
              openServerDescribe != undefined &&
              openServerDescribe != ''
            "
          >
            <span class="vip_tip">{{ openServerDescribe }}</span>
          </div>

          <div class="open_date" v-if="allDateList.length > 0">
            <span class="vip_tip">（*仅供参考，以游戏内实际情况为准）</span>

            <!-- <div class="open_date_other_data">
              <div
                class="other_data_item"
                v-for="item in otherDateList"
                :key="item"
              >
                <span id="time_day" v-if="item.split(' ')[0] == getDateTime(0)"
                  >今日</span
                >
                <span v-if="item.split(' ')[0] == getDateTime(1)" id="time_day"
                  >明日</span
                >
                <span>{{ item.split(" ")[1] }}</span>
              </div>
            </div> -->

            <div class="open_date_other_data">
              <div
                class="other_data_item"
                v-for="item in openDateList"
                :key="item"
              >
                <span id="time_day" v-if="item.split(' ')[0] == getDateTime(0)"
                  >今日</span
                >
                <span v-else-if="item.split(' ')[0] == getDateTime(1)" id="time_day"
                  >明日</span
                >
                <span v-else>{{ item.split(" ")[0] }}</span>
                <span>{{ item.split(" ")[1] }}</span>
              </div>
            </div>
          </div>

          <div class="empty" v-else>
            <img src="@/assets/images/empty.png" alt="" />
            <span>动态开服，请留意游戏内公告</span>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="game-detail-btn">
      <button @click="doOperate('download')" class="btn download">
        {{ `下载(${gameInfo.apkSize})` }}
      </button>
      <button @click="doOperate('recharge')" class="btn">
        {{ `充值(${gameInfo.discount})` }}
      </button>
    </div>

    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="plagInfo"
    ></gamePlatPopup>

    <van-share-sheet
      v-model="showShare"
      :options="shareOptions"
      @select="onSelect"
    />

    <promptPopup v-if="promptPopupVirsble" v-model="promptPopupVirsble" />
    <promptPopup2 v-if="promptPopup2Virsble" v-model="promptPopup2Virsble" />
  </div>
</template>

<script>
import Qs from "qs";
import vTable from "./components/VipTable.vue";
import pageHeader from "@/components/PageHeader.vue";
import gamePlatPopup from "@/components/GamePlatPopup.vue";
import promptPopup from "@/components/PromptPopup";
import promptPopup2 from "@/components/PromptPopup2";
import { slider, slideritem } from "vue-concise-slider";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import copy from "copy-to-clipboard";
import platform from "../../mixin/platform";
export default {
  mixins: [platform],
  name: "App",
  components: {
    vTable,
    slider,
    slideritem,
    pageHeader,
    gamePlatPopup,
    promptPopup,
    promptPopup2
  },
  data() {
    return {
      typeList: [
        { id: 1, value: "卡牌" },
        { id: 2, value: "棋牌" },
        { id: 3, value: "Q版" },
      ],
      active: 0,
      poster: "",
      videoUrl: "",
      gameTitle: "",
      options: {
        currentPage: 0,
        pagination: false,
      },
      imgList: [],
      gameImg:
        "http://image.jm3011.cn/image/20210909/e7640810247fa1250119ac31c29d5c9a.jpg;http://image.jm3011.cn/image/20210909/b5d36664262d1049e199ca48fc9f6cd2.jpg;http://image.jm3011.cn/image/20210909/bf74cd101f72bcc81a9c880fa87638fa.jpg;http://image.jm3011.cn/image/20210909/7dfbe685aebbdafdd5f23ae337e0d32b.jpg;http://image.jm3011.cn/image/20210909/b4dc3573c66b14562bfb05c129298794.jpg",
      gameDetail:
        "充值3倍提升，超高福利加快节奏激爽体验！\n2021年度国风妖灵幻想手游《伏妖绘卷（充值泄露版）》划破时空，重回盛唐，看人与妖灵共舞！绝版武器，首冲即送。累计在线时间，直升VIP，领取大礼包！梦回繁华盛唐，展现妖灵百态！华丽时装，萌宠坐骑，打造炫酷角色。驭龙乘凤玩转盛唐，斩妖除魔逍遥自在。世界BOSS，副本闯关，装备超高爆率！海战夺岛，挑战海神，收获丰厚奖励！快约上小伙伴，踏上与妖灵共舞的冒险之旅吧！",
      openDateList: [],
      allDateList: [],
      otherDateList: [],
      fistOpenDate: "",
      gameVipList: [],
      tableOption: {
        column: [
          {
            label: "vip等级",
            prop: "vipName",
          },
          {
            label: "原价",
            prop: "oldPrice",
          },
          {
            label: "万梦折扣价",
            prop: "realPrice",
          },
        ],
      },
      strategyList: [],
      gameInfo: {},
      vipDescribe: "",
      openServerDescribe: "",
      gameId: "",
      gameTypeList: [],
      UBrowser: "",
      btnType: "",
      plagInfo: {},
      gamePlatPopupVisible: false,
      showShare: false,
      shareOptions: [{ name: "复制链接", icon: "link" }],
      promptPopupVirsble: false,
      promptPopup2Virsble: false,
    };
  },
  computed: {
    ...mapGetters(["uuid", "isLogin"]),
  },
  async created() {
    this.gameId = this.$route.query.gameId;
    this.gameInfo = await this.gameDetailInfo();
    const { gameVipList, openDateList } = await this.gameDetailAdd()
    this.gameTitle = this.gameInfo.gameName;
    // document.title = this.gameTitle + "_折扣充值平台";
    this.imgList = this.setBannerImg(this.gameInfo.gameImg);
    this.poster =
      this.gameInfo.videoImgUrl && this.gameInfo.videoImgUrl.split("?")[0];
    this.videoUrl = this.gameInfo.videoUrl;
    this.UBrowser = navigator.userAgent.indexOf("UCBrowser");

    console.log(this.gameInfo, "gameInfo");
    this.gameTypeList = this.setGameTag(this.gameInfo.gameType)
      // this.gameInfo.gameType.length <= 4
      //   ? this.gameInfo.gameType
      //   : this.gameInfo.gameType.slice(0, 4);
    this.gameVipList = gameVipList || [];
    let dateList = openDateList || [];
    this.allDateList = dateList;
    
    this.vipDescribe = this.gameInfo.vipDescribe;
    this.openServerDescribe = this.gameInfo.openServerDescribe;
    dateList.forEach((date) => {
      
        let arr = date.split("-");

        this.openDateList.push(`${arr[1]}-${arr[2]}`);
    });
    
    console.log(this.openDateList, "openDateList-----");
    // dateList.forEach((info) => {
    //   if (
    //     info.split(" ")[0] == this.getDateTime(0) ||
    //     info.split(" ")[0] == this.getDateTime(1)
    //   ) {
    //     // let arr = info.split('-')
    //     this.otherDateList.push(info);
    //   }
    // });
    // console.log(this.otherDateList, 'otherDateList-')
  },
  methods: {
    /**
     * 处理游戏标签和开服信息显示
     */
    setGameTag(gameType) {
      let formatGameType = [];
      if (gameType && gameType.length) {
        let hasKouBeiBangTag = gameType.includes("口碑榜");
        let hasTeJiaTag = gameType.includes("特价");
        if (hasKouBeiBangTag && hasTeJiaTag) {
          formatGameType.push("口碑榜");
          formatGameType.push("特价");
          if (gameType.length > 2) {
            let filterArr = gameType.filter(
              (e) => e != "口碑榜" && e != "特价"
            );
            formatGameType.push(...filterArr.slice(0, 2));
          }
        } else if (!hasKouBeiBangTag && !hasTeJiaTag) {
          formatGameType.push(...gameType.slice(0, 4));
        } else if (hasKouBeiBangTag || hasTeJiaTag) {
          if (hasKouBeiBangTag) {
            formatGameType.push("口碑榜");
          }
          if (hasTeJiaTag) {
            formatGameType.push("特价");
          }
          if (gameType.length > 0) {
            let filterArr = gameType.filter(
              (e) => e != "口碑榜" && e != "特价"
            );
            formatGameType.push(...filterArr.slice(0, 3));
          }
        }
      }
      return formatGameType;
    },

    onSelect(e) {
      if (e.icon == "link") {
        copy(
          `http://wmsy666.com/wanmengapp/wm-gameshare?uuid=${this.uuid}&gameId=${this.gameInfo.gameId}`
        );
        this.$toast("链接已复制到剪切板！");
      }
    },
    async collectHandle() {
      if (!this.uuid) {
        this.$router.push("/login");
        return;
      }
      if (this.gameInfo.collected) {
        await this.unclooect();
      } else {
        await this.collect();
      }
      this.gameInfo = await this.gameDetailInfo();
    },

    async collect() {
      try {
        await requestMethods(
          "/modules/collect/gameCollect/saveOrUpdate.htm",
          "post",
          {
            gameId: this.gameId,
            uuid: this.uuid,
            appType: "WM",
          }
        );
        this.$toast("收藏成功");
      } catch (error) {
        this.$toast(error.message);
      }
    },
    async unclooect() {
      try {
        await requestMethods(
          "/modules/collect/gameCollect/delete.htm",
          "post",
          {
            gameId: this.gameId,
            uuid: this.uuid,
            appType: "WM",
          }
        );
        this.$toast("已取消收藏");
      } catch (error) {
        this.$toast(error.message);
      }
    },
    waterMarkHandle() {
      this.$router.push({path: '/welfareCollection', query: {
        waterList: JSON.stringify(this.gameInfo.gameWalfareList)
      }})
    },
    tipMessage() {
      this.$dialog.alert({
        title: "温馨提示",
        message: "请先下载游戏，进入后点击悬浮窗，免费领取礼包！",
        confirmButtonColor: "#FF7A3E",
      });
    },
    tipMessageOther() {
      this.$dialog.alert({
        title: "温馨提示",
        message: "该功能需下载万梦APP使用",
        confirmButtonColor: "#FF7A3E",
      });
    },
    // 获取今日明日时间
    getDateTime(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1; //获取当前月份的日期
      if(m < 10) {
        m = '0' + m
      }
      var d = dd.getDate();
      if(d < 10) {
        d = '0' + d
      }
      console.log(m + "-" + d)
      return m + "-" + d;
    },
    setBannerImg(gameImg) {
      let imgArr = gameImg.split(";") || [];
      return imgArr;
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    download() {
      window.location.href =
        "http://wmsy666.com/wanmengapp/wm-gameshare/wm-download";
    },
    async gameDetailInfo() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/gameDetail.htm",
          "post",
          {
            gameId: this.gameId,
            uuid: this.uuid,
            appType: "WM",
          }
        );
        const gameInfo = data;
        return gameInfo;
      } catch (error) {
        this.$toast(error.message);
      }
    },
    async gameDetailAdd() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/gameDetailAdd.htm",
          "post",
          {
            gameId: this.gameId,
            uuid: this.uuid,
            appType: "WM",
          }
        );
        const gameAddInfo = data;
        return gameAddInfo;
      } catch (error) {
        this.$toast(error.message);
      }
    },
    
    openJump(flag) {
      if (flag == 1) {
        window.open("http://wmsy666.com/privacyAgreement-xl");
      } else if (flag == 0) {
        window.open("http://wmsy666.com/permissionDes.html");
      } else if (flag == 2) {
        window.open("http://xlsy.xinyou699.cn/wmgame/ability.html");
      }
    },

    doOperate(chennel) {
      if (!this.isLogin) {
        this.$router.push("/login");
        return;
      }
      
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.plagInfo = {
        gameName: this.gameInfo.gameName,
        gameId: this.gameId
      };
      this.gamePlatPopupVisible = true;
    },
  },
};
</script>

<style lang="scss">
#app {
  background: #ffffff;

  .page_head {
    padding: 20px 34px;
    text-align: center;
    span {
      font-size: 34px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
  }

  .page_head_title {
    width: 100%;
    box-sizing: border-box;
    padding: 0.13333rem 0.45333rem;
    background: #fff;
  }

  .page_head_title .page_head_left {
    float: left;
    color: #999;
    font-size: 0.32rem;
    line-height: 0.45333rem;
  }

  .page_head_title .page_head_right {
    float: right;
    color: #999;
    font-size: 0.32rem;
    line-height: 0.45333rem;
  }

  .page_head_title .page_head_right span {
    color: #999;
    font-size: 0.32rem;
  }

  .page_head_title .clearBoth {
    clear: both;
  }

  .game_info {
    position: relative;
    .game_info_bg {
      background: url("~@/assets/images/bg.png") no-repeat;
      width: 750px;
      height: 390px;
      background-size: 100% 100%;
    }
    .bg_img {
      width: 750px;
      height: 221px;
      margin-top: 170px;
    }
    .game_detail {
      background: url("~@/assets/images/bg_write.png") no-repeat;
      width: 750px;
      height: 350px;
      background-size: 100% 100%;
      position: absolute;
      top: 20px;
      padding: 56px 63px;
      box-sizing: border-box;
      padding-right: 0;

      .game_detail_top {
        display: flex;
        // align-items: center;
        .game_logo {
          width: 150px;
          height: 150px;
          margin-right: 40px;
        }
        .game_title_desc_type {
          .game_title {
            width: 384px;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 50px;
            color: #000000;
            margin-bottom: 5px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .game_desc {
            width: 384px;
            font-size: 24px;
            line-height: 33px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #bbbbbb;
            margin-bottom: 26px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .game_type {
            display: flex;
            align-items: center;

            .game_type_item {
              background: #f8f8f8;
              border-radius: 22px;
              border: 1px solid #e6e6e6;
              font-size: 22px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #bbbbbb;
              margin-right: 10px;
              padding: 3px 15px;
            }
          }
        }
      }

      .game_detail_bottom {
        display: flex;
        // margin-top: 31px;

        .game_redate {
          background: url("~@/assets/images/icon_rebate.png") no-repeat;
          width: 118px;
          height: 59px;
          background-size: 100% 100%;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 59px;
          text-align: left;
          padding-left: 16px;
          margin-top: 20px;
        }

        .game_welfare {
          display: flex;
          // align-items: flex-end;
          margin-left: 52px;
          margin-top: 10px;
          .game_gift_btn,
          .game_welfare_btn {
            background: url("~@/assets/images/icon_btn2.png") no-repeat;
            width: 240px;
            height: 90px;
            background-size: 100% 100%;
            font-size: 26px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 90px;
            text-align: center;
          }
        }
      }
    }
  }
  .game_content {
    .vanTabs {
      font-size: 30px;
      height: 72px;

      .van-tabs__wrap {
        height: 72px;

        .van-tab__text {
          font-size: 30px;
          line-height: 30px;
        }
      }
      .van-tabs__content {
        position: relative;
        padding-bottom: 100px;
        .line_height {
          height: 10px;
          background: #f5f5f5;
          width: 750px;
        }

        .game_video_detail {
          padding: 50px 35px;
          // padding-bottom: 200px;

          .video-box {
            width: 100%;
            height: 383px;
            // margin:20px auto;
            border-radius: 16px;
            overflow: hidden;
            .video {
              width: 100%;
              height: 383px;
              object-fit: fill;
              border-radius: 16px;
            }
          }

          .game_detail_info {
            margin-top: 30px;
            font-weight: 400;
            font-size: 30px;
            color: #8f8f8f;
            line-height: 42px;
            letter-spacing: 2px;
          }
        }

        .vip_content,
        .open_date,
        .play_gl {
          padding: 30px 20px;

          .vip_tip {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
        }
        .open_date {
          .open_date_first_data {
            margin: 0 20px;
            height: 60px;
            display: flex;
            align-items: center;
            border-radius: 30px;
            border: 1px solid #ff7a3e;
            font-size: 26px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ff7a3e;
            text-align: center;
            line-height: 60px;
            margin-top: 40px;
            img {
              width: 22px;
              height: 29px;
              margin: 0 81px 0 64px;
            }
            span {
              margin-right: 30px;
            }
          }
          .open_date_other_data {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 0 20px;

            .other_data_item {
              width: 320px;
              height: 60px;
              background: #f5f5f5;
              border-radius: 30px;
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #414141;
              line-height: 60px;
              // text-align: center;
              margin-top: 20px;
              display: flex;
              align-items: center;

              #time_day {
                font-size: 24px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ff7a3e;
                // margin-right: 67px;
              }
              span {
                display: block;

                &:first-child {
                  width: 120px;
                  margin-left: 50px;
                }
                &:last-child {
                  width: 160px;
                }
              }
            }
          }
        }
        .empty {
          margin: 0 auto;
          text-align: center;
          margin-top: 100px;
          img {
            width: 180px;
            height: 140px;
          }
          span {
            display: block;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #bbbbbb;
            line-height: 33px;
            margin-top: 6px;
          }
        }
        .play_gl {
          .vip_tip {
            display: block;
            margin-bottom: 67px;
          }
          .play_gl_item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 30px 30px 60px;
            padding-bottom: 30px;
            border-bottom: 1px solid #e6e6e6;

            .play_item_name {
              width: 400px;
              font-size: 32px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #000000;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .play_item_time {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #bbbbbb;
              margin-top: 7px;
              display: block;
            }
            .play_item_logo {
              width: 200px;
              height: 130px;
              border-radius: 5px;
            }
          }
        }
      }
    }
  }
  .game-detail-btn {
    background: #fff;
    width: 750px;
    height: 100px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;

    .btn {
      width: 340px;
      height: 80px;
      background: #ff7a3e;
      border-radius: 45px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      line-height: 80px;
      border: none;
    }
    .download {
      background: #ffa754;
    }
  }
  .sliderImg {
    width: 270px;
    border-radius: 20px;
  }

  .bottom {
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    padding: 50px 0;
  }

  .bottom span {
    text-align: left;
    color: #999;
    font-size: 0.37333rem;
    margin-bottom: 35px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/detail/index.vue